export default __webpack_public_path__ + "static/taskdefinition9-6a613e716c765b1adf1602292b832e64.png";